export default __webpack_public_path__ + "static/media/down-square-o.24eb56ba.svg";